export const getExpiry = expiry => {
    switch (expiry) {
        case 0:
            return 'None';
        case 1:
            return 'From issue';
        case 2:
            return 'Fixed date';
        default:
            return;
    }
};

export const getCredits = (credits, classLimit) => {
    if (classLimit === 0) return 'N/A';
    return credits;
};

export const getClassLimit = classLimit => {
    switch (classLimit) {
        case 0:
            return 'Unlimited';
        case 1:
            return 'Credits based';
        case 2:
            return 'Online only';
        default:
            return;
    }
};

export const setAvailableClasses = classes => {
    if (classes.length === 0) return [];
    const usedSeriesIds = [];
    const availableClasses = [];

    classes.forEach(_class => {
        if (!usedSeriesIds.includes(_class.seriesId)) usedSeriesIds.push(_class.seriesId);
    });

    for (let i = 0; i < usedSeriesIds.length; i++) {
        for (let j = 0; j < classes.length; j++) {
            if (classes[j].seriesId === usedSeriesIds[i]) {
                availableClasses.push({ title: classes[j].name, value: classes[j].seriesId });
                i++;
            }
        }
    }

    return availableClasses;
};

export const getAvailableClasses = classes => {
    if (classes.length === 0) return 'Select clasess';
    const classesArray = classes.map(_class => _class.title);
    return classesArray.join(', ');
};

export const getRegularity = regularity => {
    switch (regularity) {
        case 0:
            return 'One off payment';
        case 1:
            return 'Every month';
        case 2:
            return '1st and 15th';
        case 3:
            return '10th and 25th';
        case 4:
            return 'Every week';
        case 5:
            return 'Every 2 weeks';
        case 6:
            return 'Every 3 weeks';
        case 7:
            return 'Every 4 weeks';
        case 8:
            return 'Every 1 month';
        case 9:
            return 'Every 2 months';
        case 10:
            return 'Every 3 months';
        case 11:
            return 'Every 4 months';
        case 12:
            return 'Every 6 months';
        default:
            return 'None';
    }
};

export const setCredits = credits => {
    // const { classLimit } = this.state;
    // if (credits === null)

    // if (classLimit === 0) return 'N/A';
    return credits;
};

export const setClassLimit = (credits, isOnline) => {
    if (isOnline) return 2;
    if (credits) return 1;
    return 0;
};

export const setExpiry = (deadlineDate, deadlineDays) => {
    if (deadlineDate) return 2;
    if (deadlineDays) return 1;
    return 0;
};

export const selectInputOnFocus = e => {
    e.target.select();
};



// WEBPACK FOOTER //
// ./src/UI/Components/Rows/MembershipPlanRow/utils.js